type GlobalsItem = {
    [key: string]: unknown;
}

type NsjGlobalsType = {
    a: GlobalsItem;
    set(globals: { [key: string]: unknown }): void;
    get(param: string): GlobalsItem | null;
    getInstance(): NsjGlobalsType;
}

declare const nsjGlobals: NsjGlobalsType;

export default nsjGlobals;
